import React from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    Button,
    Text,
    Flex,
    Icon,
    useColorModeValue,
} from "@chakra-ui/react";

const DeleteModal = ({
    isOpen,
    onClose,
    onDelete,
    icon,
    heading,
    description,
    deleteButtonText = "Delete",
    cancelButtonText = "Cancel",
    type = "delete",
}) => {
    const textColor = useColorModeValue("secondaryGray.900", "white");
    const bgColor = useColorModeValue("white", "navy.800");

    const getButtonColorScheme = () => {
        switch (type) {
            case 'delete':
                return 'red';
            case 'success':
                return 'green';
            case 'pending':
                return 'gray';
            default:
                return 'red';
        }
    };

    const getIconBgColor = () => {
        switch (type) {
            case 'delete':
                return 'red.100';
            case 'success':
                return 'green.100';
            case 'pending':
                return 'gray.100';
            default:
                return 'red.100';
        }
    };

    const getIconColor = () => {
        switch (type) {
            case 'delete':
                return 'red.500';
            case 'success':
                return 'green.500';
            case 'pending':
                return 'gray.500';
            default:
                return 'red.500';
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
            <ModalOverlay />
            <ModalContent
                bg={bgColor}
                borderRadius="16px"
                p="24px"
            >
                <ModalHeader
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    textAlign="center"
                    color={textColor}
                    fontSize="24px"
                    fontWeight="700"
                    pt="20px"
                >
                    <Flex
                        align="center"
                        justify="center"
                        w="64px"
                        h="64px"
                        borderRadius="50%"
                        bg={getIconBgColor()}
                        mb="16px"
                    >
                        <Icon as={icon} w="32px" h="32px" color={getIconColor()} />
                    </Flex>
                    {heading}
                </ModalHeader>
                <ModalCloseButton color="gray.500" />
                <ModalBody textAlign="center" px="20px" pb="24px">
                    <Text color="gray.500" fontSize="16px" fontWeight="400" mb="24px">
                        {description}
                    </Text>
                    <Flex justify="center" gap="16px">
                        <Button
                            variant="outline"
                            colorScheme="gray"
                            onClick={onClose}
                            fontSize="14px"
                            fontWeight="500"
                            px="24px"
                            py="12px"
                            width="100px"
                            height="40px"
                            borderRadius="6px"
                        >
                            {cancelButtonText}
                        </Button>
                        <Button
                            colorScheme={getButtonColorScheme()}
                            onClick={onDelete}
                            fontSize="14px"
                            fontWeight="500"
                            px="24px"
                            py="12px"
                            width="100px"
                            height="40px"
                            borderRadius="6px"
                        >
                            {deleteButtonText}
                        </Button>
                    </Flex>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default DeleteModal; 